export const UPLOAD_CONFIG = {
  MAX_IMAGE_SIZE: 2 * 1024 * 1024, // 2MB
  MAX_PDF_SIZE: 5 * 1024 * 1024,   // 5MB
  ACCEPTED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  ACCEPTED_PDF_TYPES: ['application/pdf']
} as const;

export type UploadConfig = typeof UPLOAD_CONFIG;